import { Tag } from 'antd';
import React, { FC, useCallback } from 'react';

export const DEFAULT_PAYMENT_TERMS = {
	NET_30: 'Net 30',
	NET_45: 'Net 45',
	NET_60: 'Net 60',
	NET_90: 'Net 90',
};

const InvoicePaymentTermComponent: FC<any> = ({ onSelect }): React.ReactElement => {
	const values = [
		{
			label: DEFAULT_PAYMENT_TERMS.NET_30,
		},
		{
			label: DEFAULT_PAYMENT_TERMS.NET_45,
		},
		{
			label: DEFAULT_PAYMENT_TERMS.NET_60,
		},
		{
			label: DEFAULT_PAYMENT_TERMS.NET_90,
		},
	];

	const onClick = useCallback((val) => () => onSelect(val), [onSelect]);

	return (
		<div className="mt-2 flex flex-row items-center">
			{values.map((val, idx) => (
				<Tag
					key={`pt-${idx}`}
					color="purple"
					className="mr-2 cursor-pointer"
					onClick={onClick(val.label)}
				>
					{val.label}
				</Tag>
			))}
		</div>
	);
};

export default InvoicePaymentTermComponent;
